export const roleColumns = [
    {
        Header: 'Name',
        accessor: 'name',
        enableFilter: true,
    },
    {
        Header: 'Description',
        accessor: 'description',
        enableFilter: true,
    },
    {
        Header: 'Status',
        accessor: 'status',
        enableFilter: true,
        type: 'enum',
        filterOptions: [
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
    },
];
